import { RouteSortBy, SortDirection } from '@/api/dto'

export const DEFAULT_ROUTE_SORT_BY = RouteSortBy.DATE_TIME
export const DEFAULT_ROUTE_SORT_DIR = SortDirection.DESC
